import React, { useEffect, useState, useContext } from 'react';
import { loadFromCache, loadTitleCache ,deleteFromCache} from './CacheHandler';
import { ModeContext } from './ModeContext';
import Button from '@mui/material/Button';
import { IconButton, Tooltip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteIcon from '@mui/icons-material/Delete';
import Collapse from '@mui/material/Collapse';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import QuizIcon from '@mui/icons-material/Quiz';
import HistoryIcon from '@mui/icons-material/History';

const SettingsSidebar = () => {
  const {activeAdminComponent, setActiveAdminComponent, loginInfo} = useContext(ModeContext);
  
  const handleIconClick = (component) => {
    setActiveAdminComponent(component);
  };

  return (
    <div className="sidebar-options">
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {/* ユーザー設定はadminとHQのみ表示 */}
        {(loginInfo.authorityId === 'admin' || loginInfo.authorityId === 'HQ') && (
        <li 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginBottom: '10px' ,
            backgroundColor: activeAdminComponent === 'AdminUserSetting' ? '#e0e0e0' : 'transparent',
          }} 
          onClick={() => handleIconClick('AdminUserSetting')}
        >
          <ManageAccountsIcon sx={{ marginRight: '5px' }} />
          ユーザー設定
        </li>
        )}

        {/* 以下のメニューはHQ以外に表示 */}
        {loginInfo.authorityId !== 'HQ' && (
        <>
        <li 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' , marginBottom: '10px' ,
            backgroundColor: activeAdminComponent === 'AdminPromptSetting' ? '#e0e0e0' : 'transparent',
          }} 
          onClick={() => handleIconClick('AdminPromptSetting')}
        >
          <BlurOnIcon sx={{ marginRight: '5px' }} />
          プロンプト
        </li>

        <li 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' , marginBottom: '10px' ,
            backgroundColor: activeAdminComponent === 'AdminDocSetting' ? '#e0e0e0' : 'transparent',
          }} 
          onClick={() => handleIconClick('AdminDocSetting')}
        >
          <FileUploadIcon sx={{ marginRight: '5px' }} />
          取扱説明書_取込み
        </li>

        <li 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' , marginBottom: '10px' ,
            backgroundColor: activeAdminComponent === 'AdminDocTrkSetting' ? '#e0e0e0' : 'transparent',
          }} 
          onClick={() => handleIconClick('AdminDocTrkSetting')}
        >
          <FileUploadIcon sx={{ marginRight: '5px' }} />
          サービスマニュアル_取込み
        </li>

        <li 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' , marginBottom: '10px' ,
            backgroundColor: activeAdminComponent === 'AdminKnowledgeFaqSetting' ? '#e0e0e0' : 'transparent',
          }} 
          onClick={() => handleIconClick('AdminKnowledgeFaqSetting')}
        >
          <QuizIcon sx={{ marginRight: '5px' }} />
          ナレッジ/FAQ/ルール登録
        </li>
        </>
        )}

        {/* 質問履歴ダウンロードは全権限で表示 */}
        <li 
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' , marginBottom: '10px' ,
            backgroundColor: activeAdminComponent === 'AdminHistoryDownload' ? '#e0e0e0' : 'transparent',
          }} 
          onClick={() => handleIconClick('AdminHistoryDownload')}
        >
          <HistoryIcon sx={{ marginRight: '5px' }} />
          質問履歴ダウンロード
        </li>

      </ul>
    </div>
  );

};

export default SettingsSidebar;
